import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "..";

const requestBaseQuery = baseQuery("cart", "* , product:product_id(*)");

export const cartApi = createApi({
  reducerPath: "cartDetails",
  baseQuery: requestBaseQuery,
  tagTypes: ["cart"],
  endpoints: (builder) => ({
    addItemtoCart: builder.mutation({
      query: (details) => ({ type: "POST", data: details }),
      invalidatesTags: [{ type: "cart", id: "LIST" }],
    }),
    getCartItems: builder.query({
      query: ({ filter }) => ({
        type: "GET",
        filters: filter ?? undefined,
      }),
      providesTags: () => [{ type: "cart", id: "LIST" }],
    }),
    updateItem: builder.mutation({
      query: (data) => ({ type: "PATCH", data: data, id: data.id }),
      invalidatesTags: ["cart"],
    }),
    deleteItem: builder.mutation({
      query: (id) => ({ type: "DELETE", id }),
      invalidatesTags: [{ type: "cart", id: "LIST" }],
    }),
    deleteAllItems: builder.mutation({
      query: (userId) => ({ 
        type: "DELETE", 
        body: { user_id: userId },
       }),
      invalidatesTags: [{ type: "cart", id: "LIST" }],
    }),
  }),
});

export const {
  useAddItemtoCartMutation,
  useGetCartItemsQuery,
  useDeleteItemMutation,
  useUpdateItemMutation,
  useDeleteAllItemsMutation
} = cartApi;
